import { Sleep, UnixTime } from "@pdfking/tfunc"
import { SafePromise } from "@pdfking/tfunc"
import * as tracker_names from "@pdfking/translations/enum/trackers"
import filter from "rfuncs/functions/filter"
import identity from "rfuncs/functions/identity"
import items from "rfuncs/functions/items"
import keys from "rfuncs/functions/keys"
import length from "rfuncs/functions/length"
import object_map from "rfuncs/functions/object_map"
import partial from "rfuncs/functions/partial"
import values from "rfuncs/functions/values"

import { RegisterCallbacks } from "../actions/pdfengine/RegisterCallback"
import fire_event from "../utils/fire_event"
import make_translations from "../utils/make_translations"
import render_string from "../utils/render_string"
import uuid from "../utils/uuid"
import delete_property from "../vue/3/delete_property"
import virtual from "../vue/3/virtual"

export default virtual({
  data() {
    return {
      tasks: {},
    }
  },
  methods: {
    track_promise(promise_factory) {
      const task_id = uuid()
      this.start(task_id)

      const promise = Promise.resolve(
        promise_factory(event => this.emit(task_id, event.name, task_id, event))
      )
      SafePromise(promise).then(({ error }) => {
        this.finish(task_id, error)
      })

      return promise
    },
    start(task_id) {
      const r = this.tasks[task_id]
      return (
        r ||
        (this.tasks[task_id] = {
          error: null,
          finished: false,
          status: {},
          start_at: UnixTime(),
        })
      )
    },
    emit(task_id, progress_type, progress_id, { done = null, total = null }) {
      //console.info("task updated", {task_id,progress_type,progress_id,done, total})

      const t = this.start(task_id)
      if (!t.status[progress_type]) {
        t.status[progress_type] = {}
      }
      if (!t.status[progress_type][progress_id]) {
        t.status[progress_type][progress_id] = {}
      }
      const r = t.status[progress_type][progress_id]
      r.done = done || r.done || 0
      r.total = Math.max(total || r.total || 1, r.done)

      if (r.done === r.total) this.finish(task_id)
    },
    finish(task_id, error, timeout = null) {
      // console.info("task finished", { task_id, error })

      const t = this.start(task_id)

      t.finished = true
      t.error = error
      for (const s of values(t.status)) {
        for (const c of values(s)) {
          c.done = c.total
        }
      }
      const delay = error ? 5000 : timeout || 2500
      Sleep(delay).then(partial(this.cleanup_tracker, task_id))

      error ? fire_event(document, "tracked_error", error) : null
    },
    cleanup_tracker(task_id) {
      const to_delete = keys(
        filter((t, id) => t.aggregated.is_finished, this.trackers)
      )
      for (const [task_id, t] of items(this.tasks)) {
        for (const id of to_delete) {
          delete_property(t.status, id)
        }
        if (length(t.status) == 0) {
          delete_property(this.tasks, task_id)
        }
      }
    },
  },
  computed: {
    translations: () => make_translations("trackers"),
    is_loading() {
      return length(this.trackers) > 0
    },
    trackers() {
      const blank = () => ({
        done: 0,
        total: 0,
        task_done: 0,
        task_total: 0,
        get is_finished() {
          return this.task_total - this.task_done == 0
        },
      })
      const trackers = object_map(
        identity,
        id => {
          const trans = this.translations.trackers[id]
          return {
            get title() {
              return trans ? render_string(trans, this.aggregated) : null
            },
            get width() {
              return 1 / length(trackers)
            },
            status: object_map(
              identity,
              k => ({
                ...blank(),
                get width() {
                  return this.done / trackers[id].aggregated.total
                },
              }),
              ["danger", "success", "loading"]
            ),
            aggregated: blank(),
          }
        },
        tracker_names
      )
      for (const [task_id, task] of items(this.tasks)) {
        const key = task.error
          ? "danger"
          : task.finished
            ? "success"
            : "loading"
        for (const [id, counters] of items(task.status)) {
          for (const { done, total } of values(counters)) {
            for (const r of [
              trackers[id].status[key],
              trackers[id].aggregated,
            ]) {
              r.done += done
              r.total += total
              r.task_done += task.finished ? 1 : 0
              r.task_total += 1
            }
          }
        }
      }
      for (const [id, { aggregated }] of items(trackers)) {
        if (!aggregated.task_total) {
          delete trackers[id]
        }
      }
      return trackers
    },
  },
  mounted() {
    RegisterCallbacks({
      start: task_id => this.start(task_id),
      push: (task_id, event) => this.emit(task_id, event.name, task_id, event),
      stop: (task_id, error) => this.finish(task_id, error),
    })
  },
})
